export default "/assets/images/big-sneeze-small.340ef5fcb818db54.png";